import { render, staticRenderFns } from "./cell.vue?vue&type=template&id=2fe1f167&scoped=true&"
import script from "./cell.vue?vue&type=script&lang=js&"
export * from "./cell.vue?vue&type=script&lang=js&"
import style0 from "./cell.vue?vue&type=style&index=0&id=2fe1f167&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe1f167",
  null
  
)

export default component.exports